import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const router = new Router({
    mode: "history",
    base: process.env.BASE_URL,
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
    routes: [{
            // =============================================================================
            // MAIN LAYOUT ROUTES
            // =============================================================================
            path: "",
            component: () =>
                import ("./layouts/main/Main.vue"),
            meta: { requiresAuth: true },
            children: [
                // =============================================================================
                // Theme Routes
                // =============================================================================
                {
                    path: "/dashboard",
                    name: "dashboard",
                    meta: {
                        menuName: "Dashboard"
                    },
                    component: () =>
                        import ("./views/dashboard/Index.vue")
                },
                // START REPORT
                {
                    path: "/report/operation-dashboard",
                    name: "Dashboard",
                    meta: {
                        menuName: "Dashboard"
                    },
                    component: () =>
                        import ("./views/report/dashboard/Index.vue")
                },
                {
                    path: "/report/im-inventory",
                    name: "im-inventory",
                    meta: {
                        menuName: "IM Inventory"
                    },
                    component: () =>
                        import ("./views/report/im-inventory/Index.vue")
                },
                {
                    path: "/report/inventory-mutation",
                    name: "inventory-mutation",
                    meta: {
                        menuName: "Inventory Mutation"
                    },
                    component: () =>
                        import ("./views/report/inventory-mutation/Index.vue")
                },
                {
                    path: "/report/inventory-balance",
                    name: "inventory-balance",
                    meta: {
                        menuName: "Inventory Balance"
                    },
                    component: () =>
                        import ("./views/report/inventory-balance/Index.vue")
                },
                {
                    path: "/report/location-status",
                    name: "location-status",
                    meta: {
                        menuName: "Location Status"
                    },
                    component: () =>
                        import ("./views/report/locationstatus/Index.vue")
                },
                {
                    path: "/report/im-transaction",
                    name: "im-transaction",
                    meta: {
                        menuName: "IM Transaction"
                    },
                    component: () =>
                        import ("./views/report/im-transaction/Index.vue")
                },
                {
                    path: "/report/warehouse-cost",
                    name: "warehouse-cost",
                    meta: {
                        menuName: "Warehouse Cost"
                    },
                    component: () =>
                        import ("./views/report/warehouse-cost/Index.vue")
                },
                {
                    path: "/report/invnokia-rdri",
                    name: "invnokia-rdri",
                    meta: {
                        menuName: "RDRI"
                    },
                    component: () =>
                        import ("./views/report/invnokia-rdri/Index.vue")
                },
                {
                    path: "/report/shipment",
                    name: "shipment",
                    meta: {
                        menuName: "Shipment"
                    },
                    component: () =>
                        import ("./views/report/shipment/Index.vue")
                },
                {
                    path: "/report/wm-inventory",
                    name: "wm-inventory",
                    meta: {
                        menuName: "WM Inventory"
                    },
                    component: () =>
                        import ("./views/report/wminventory/Index.vue")
                },
                // END REPORT
                // START ROLE MANAGEMENT
                {
                    path: "/menu",
                    name: "menu",
                    meta: {
                        menuName: "Menu"
                    },
                    component: () =>
                        import ("./views/rolemanagement/menu/Index.vue")
                },
                {
                    path: "/menu/view",
                    name: "menu-view",
                    meta: {
                        menuName: "Menu"
                    },
                    component: () =>
                        import ("./views/rolemanagement/menu/ViewEdit.vue")
                },
                {
                    path: "/menu/add",
                    name: "menu-add",
                    meta: {
                        menuName: "Menu"
                    },
                    component: () =>
                        import ("./views/rolemanagement/menu/Add.vue")
                },
                {
                    path: "/usergroup",
                    name: "usergroup",
                    meta: {
                        menuName: "User Group"
                    },
                    component: () =>
                        import ("./views/rolemanagement/usergroup/Index.vue")
                },
                {
                    path: "/usergroup/view",
                    name: "usergroup-view",
                    meta: {
                        menuName: "User Group"
                    },
                    component: () =>
                        import ("./views/rolemanagement/usergroup/View.vue")
                },
                {
                    path: "/usergroup/add",
                    name: "usergroup-add",
                    meta: {
                        menuName: "User Group"
                    },
                    component: () =>
                        import ("./views/rolemanagement/usergroup/Add.vue")
                },
                {
                    path: "/user",
                    name: "user",
                    meta: {
                        menuName: "Users"
                    },
                    component: () =>
                        import ("./views/rolemanagement/user/Index.vue")
                },
                {
                    path: "/user/view",
                    name: "user-view",
                    meta: {
                        menuName: "Users"
                    },
                    component: () =>
                        import ("./views/rolemanagement/user/ViewEdit.vue")
                },
                {
                    path: "/user/add",
                    name: "user-add",
                    meta: {
                        menuName: "Users"
                    },
                    component: () =>
                        import ("./views/rolemanagement/user/Add.vue")
                },
                {
                    path: "/user/change-password",
                    name: "user-change-password",
                    meta: {
                        menuName: "Users"
                    },
                    component: () =>
                        import ("./views/rolemanagement/user/ChangePassword.vue")
                },
                // END ROLE MANAGEMENT
                {
                    path: "/inbound-delivery",
                    name: "inbound-delivery",
                    meta: {
                        menuName: "Inbound Delivery"
                    },
                    component: () =>
                        import ("./views/Inbound/InboundDelivery.vue")
                },
                {
                    path: "/inbound-delivery/create",
                    name: "inbound-delivery-create",
                    meta: {
                        menuName: "Inbound Delivery"
                    },
                    component: () =>
                        import ("./views/Inbound/InboundDeliveryCreate.vue")
                },
                {
                    path: "/inbound-delivery/view",
                    name: "inbound-delivery-view",
                    meta: {
                        menuName: "Inbound Delivery"
                    },
                    component: () =>
                        import ("./views/Inbound/InboundDeliveryViewEdit.vue")
                },
                {
                    path: "/surat-pesanan",
                    name: "surat-pesanan",
                    meta: {
                        menuName: "Surat Pesanan"
                    },
                    component: () =>
                        import ("./views/suratpesanan/Index.vue")
                },
                {
                    path: "/surat-pesanan/permohonan/create",
                    name: "permohonan-surat-pesanan-create",
                    meta: {
                        menuName: "Permohonan Surat Pesanan"
                    },
                    component: () =>
                        import ("./views/suratpesanan/Addpermohonan.vue")
                },
                {
                    path: "/surat-pesanan/create",
                    name: "surat-pesanan-create",
                    meta: {
                        menuName: "Surat Pesanan"
                    },
                    component: () =>
                        import ("./views/suratpesanan/Add.vue")
                },
                {
                    path: "/surat-pesanan/:id/approval",
                    name: "surat-pesanan-approval",
                    meta: {
                        menuName: "Surat Pesanan"
                    },
                    component: () =>
                        import ("./views/suratpesanan/Approval.vue")
                },
                {
                    path: "/sppmtdoi/:id/approval",
                    name: "sppmtdoi-approval",
                    meta: {
                        menuName: "SPPMTDOI"
                    },
                    component: () =>
                        import ("./views/sppmtdoi/Approval.vue")
                },
                {
                    path: "/good-receive",
                    name: "good-receive",
                    meta: {
                        menuName: "Good Receiving"
                    },
                    component: () =>
                        import ("./views/Inbound/GoodReceive.vue")
                },
                {
                    path: "/good-receive/create",
                    name: "good-receive-create",
                    meta: {
                        menuName: "Good Receiving"
                    },
                    component: () =>
                        import ("./views/Inbound/GoodReceiveCreate.vue")
                },
                {
                    path: "/good-receive/view",
                    name: "good-receive-view",
                    meta: {
                        menuName: "Good Receiving"
                    },
                    component: () =>
                        import ("./views/Inbound/GoodReceiveViewEdit.vue")
                },
                {
                    path: "/good-receive/item-check",
                    name: "item-check",
                    meta: {
                        menuName: "Good Receiving"
                    },
                    component: () =>
                        import ("./views/Inbound/ItemCheck.vue")
                },
                {
                    path: "/good-receive/putaway-background",
                    name: "putaway-background",
                    meta: {
                        menuName: "Good Receiving"
                    },
                    component: () =>
                        import ("./views/Inbound/PutAwayBackground.vue")
                },
                {
                    path: "/good-receive/putaway-foreground",
                    name: "putaway-foreground",
                    meta: {
                        menuName: "Good Receiving"
                    },
                    component: () =>
                        import ("./views/Inbound/PutAwayForeground.vue")
                },
                {
                    path: "/good-receive/reverse-putaway",
                    name: "gr-reverse-putaway",
                    meta: {
                        menuName: "Good Receiving"
                    },
                    component: () =>
                        import ("./views/Inbound/ReversePutaway.vue")
                },
                {
                    path: "/good-receive/cancel",
                    name: "cancel-gr",
                    meta: {
                        menuName: "Good Receiving"
                    },
                    component: () =>
                        import ("./views/Inbound/CancelGoodReceive.vue")
                },

                {
                    path: "/home",
                    name: "home",
                    component: () =>
                        import ("./views/Home.vue")
                },
                {
                    path: "/page2",
                    name: "page-2",
                    component: () =>
                        import ("./views/Page2.vue")
                },
                // START OUTBOUND
                {
                    path: "/outbound-delivery",
                    name: "outbound-delivery",
                    meta: {
                        menuName: "Outbound Delivery"
                    },
                    component: () =>
                        import ("./views/outbound/Index.vue")
                },
                {
                    path: "/outbound-delivery/add",
                    name: "outbound-add",
                    meta: {
                        menuName: "Outbound Delivery"
                    },
                    component: () =>
                        import ("./views/outbound/Add.vue")
                },
                {
                    path: "/outbound-delivery/view",
                    name: "outbound-view",
                    meta: {
                        menuName: "Outbound Delivery"
                    },
                    component: () =>
                        import ("./views/outbound/ViewEdit.vue")
                },
                // END OUTBOUND

                // START TRANSPORT

                // START TRANSPORT

                {
                    path: "/transportorder",
                    name: "transportorder",
                    meta: {
                        menuName: "Transporter Order"
                    },
                    component: () =>
                        import ("./views/transport/transportorder/Index.vue")
                },

                {
                    path: "/transportorder/add",
                    name: "transportorder-add",
                    meta: {
                        menuName: "Transporter Order"
                    },
                    component: () =>
                        import ("./views/transport/transportorder/Add.vue")
                },

                {
                    path: "/transportorder/view",
                    name: "transportorder-view",
                    meta: {
                        menuName: "Transporter Order"
                    },
                    component: () =>
                        import ("./views/transport/transportorder/ViewEdit.vue")
                },
                //Transport Order manual
                {
                    path: "/transportorder2",
                    name: "transportorder2",
                    meta: {
                        menuName: "Transporter Order 2"
                    },
                    component: () =>
                        import ("./views/transport/transportorder2/Index.vue")
                },
                {
                    path: "/transportorder2/add",
                    name: "transportorder2-add",
                    meta: {
                        menuName: "Transporter Order 2"
                    },
                    component: () =>
                        import ("./views/transport/transportorder2/Add.vue")
                },
                {
                    path: "/transportorder2/view",
                    name: "transportorder2-view",
                    meta: {
                        menuName: "Transporter Order 2"
                    },
                    component: () =>
                        import ("./views/transport/transportorder2/ViewEdit.vue")
                },

                //Transport Order manual
                {
                    path: "/transportorder2",
                    name: "transportorder2",
                    meta: {
                        menuName: "Transporter Order 2"
                    },
                    component: () =>
                        import ("./views/transport/transportorder2/Index.vue")
                },
                {
                    path: "/transportorder2/add",
                    name: "transportorder2-add",
                    meta: {
                        menuName: "Transporter Order 2"
                    },
                    component: () =>
                        import ("./views/transport/transportorder2/Add.vue")
                },
                {
                    path: "/transportorder2/view",
                    name: "transportorder2-view",
                    meta: {
                        menuName: "Transporter Order 2"
                    },
                    component: () =>
                        import ("./views/transport/transportorder2/ViewEdit.vue")
                },


                {
                    path: "/routeplanning",
                    name: "routeplanning",
                    meta: {
                        menuName: "Route Planning"
                    },
                    component: () =>
                        import ("./views/transport/routeplanning/Index.vue")
                },
                {
                    path: "/shuttle",
                    name: "shuttle",
                    meta: {
                        menuName: "Shuttle"
                    },
                    component: () =>
                        import ("./views/transport/shuttle/Index.vue")
                },
                {
                    path: "/routeplanning_noninternal",
                    name: "routeplanning_noninternal",
                    meta: {
                        menuName: "Route Planning Non-Internal"
                    },
                    component: () =>
                        import ("./views/transport/routeplanning_noninternal/Index.vue")
                },
                {
                    path: "/transport/track-awb",
                    name: "track-awb",
                    meta: {
                        menuName: "Track AWB"
                    },
                    component: () =>
                        import ("./views/transport/trackawb/Track.vue")
                },

                // {
                //   path: "/routeplanning/add",
                //   name: "routeplanning-add",
                //   meta: {
                //     menuName: "Route Planning"
                //   },
                //   component: () => import("./views/transport/routeplanning/Add.vue")
                // },

                // {
                //   path: "/routeplanning/view",
                //   name: "routeplanning-view",
                //   meta: {
                //     menuName: "Route Planning"
                //   },
                //   component: () =>
                //     import("./views/transport/routeplanning/ViewEdit.vue")
                // },
                {
                    path: "/pod",
                    name: "pod",
                    meta: {
                        menuName: "POD"
                    },
                    component: () =>
                        import ("./views/transport/pod/Index.vue")
                },
                {
                    path: "/pod/view",
                    name: "pod-view",
                    meta: {
                        menuName: "POD"
                    },
                    component: () =>
                        import ("./views/transport/pod/ViewEditList.vue")
                },

                {
                    path: "/invoicetransporter",
                    name: "invoicetransporter",
                    meta: {
                        menuName: "Invoice Transporter"
                    },
                    component: () =>
                        import ("./views/transport/finance/invoice-transporter/Index.vue")
                },
                {
                    path: "/invoicetransporter/add",
                    name: "invoicetransporter-add",
                    meta: {
                        menuName: "Invoice Transporter"
                    },
                    component: () =>
                        import ("./views/transport/finance/invoice-transporter/Add.vue")
                },

                {
                    path: "/invoicetransporter/view",
                    name: "invoicetransporter-view",
                    meta: {
                        menuName: "Invoice Transporter"
                    },
                    component: () =>
                        import ("./views/transport/finance/invoice-transporter/ViewEdit.vue")
                },
                {
                    path: "/invoiceclient",
                    name: "invoiceclient",
                    meta: {
                        menuName: "Invoice Client"
                    },
                    component: () =>
                        import ("./views/transport/finance/invoice-client/Index.vue")
                },
                {
                    path: "/invoiceclient/add",
                    name: "invoiceclient-add",
                    meta: {
                        menuName: "Invoice Client"
                    },
                    component: () =>
                        import ("./views/transport/finance/invoice-client/Add.vue")
                },

                {
                    path: "/invoiceclient/view",
                    name: "invoiceclient-view",
                    meta: {
                        menuName: "Invoice Client"
                    },
                    component: () =>
                        import ("./views/transport/finance/invoice-client/ViewEdit.vue")
                },
                // END TRANSPORT

                // START DO
                {
                    path: "/delivery-order",
                    name: "delivery-order",
                    meta: {
                        menuName: "Delivery Order"
                    },
                    component: () =>
                        import ("./views/deliveryorder/Index.vue")
                },
                {
                    path: "/delivery-order/add",
                    name: "delivery-order-add",
                    meta: {
                        menuName: "Delivery Order"
                    },
                    component: () =>
                        import ("./views/deliveryorder/Add.vue")
                },
                {
                    path: "/delivery-order/view",
                    name: "delivery-order-view",
                    meta: {
                        menuName: "Delivery Order"
                    },
                    component: () =>
                        import ("./views/deliveryorder/ViewEdit.vue")
                },
                {
                    path: "/delivery-order/background",
                    name: "delivery-order-background",
                    meta: {
                        menuName: "Delivery Order"
                    },
                    component: () =>
                        import ("./views/deliveryorder/Background.vue")
                },
                {
                    path: "/delivery-order/foreground",
                    name: "delivery-order-foreground",
                    meta: {
                        menuName: "Delivery Order"
                    },
                    component: () =>
                        import ("./views/deliveryorder/Foreground.vue")
                },
                {
                    path: "/delivery-order/background-reverse",
                    name: "delivery-order-background-reverse",
                    meta: {
                        menuName: "Delivery Order"
                    },
                    component: () =>
                        import ("./views/deliveryorder/BackgroundReverse.vue")
                },
                {
                    path: "/delivery-order/foreground-reverse",
                    name: "delivery-order-foreground-reverse",
                    meta: {
                        menuName: "Delivery Order"
                    },
                    component: () =>
                        import ("./views/deliveryorder/ForegroundReverse.vue")
                },
                {
                    path: "/delivery-order/check",
                    name: "delivery-order-check",
                    meta: {
                        menuName: "Delivery Order"
                    },
                    component: () =>
                        import ("./views/deliveryorder/Check.vue")
                },
                {
                    path: "/delivery-order/pack",
                    name: "delivery-order-pack",
                    meta: {
                        menuName: "Delivery Order"
                    },
                    component: () =>
                        import ("./views/deliveryorder/Pack.vue")
                },
                {
                    path: "/wave-pick-planning",
                    name: "wave-pick-planning",
                    meta: {
                        menuName: "Wave Pick Planning"
                    },
                    component: () =>
                        import ("./views/outbound/wavepick/Index.vue")
                },
                {
                    path: "/wave-pick-planning/add",
                    name: "wave-pick-planning-add",
                    meta: {
                        menuName: "Wave Pick Planning"
                    },
                    component: () =>
                        import ("./views/outbound/wavepick/Add.vue")
                },
                {
                    path: "/wave-pick-planning/view",
                    name: "wave-pick-planning-view",
                    meta: {
                        menuName: "Wave Pick Planning"
                    },
                    component: () =>
                        import ("./views/outbound/wavepick/View.vue")
                },
                {
                    path: "/wave-pick-planning/check",
                    name: "wave-pick-planning-check",
                    meta: {
                        menuName: "Wave Pick Planning"
                    },
                    component: () =>
                        import ("./views/wavepickplanning/Check.vue")
                },
                {
                    path: "/pick-list",
                    name: "pick-list",
                    meta: {
                        menuName: "Picking List"
                    },
                    component: () =>
                        import ("./views/checking/Index.vue")
                        // component: () => import("./views/picklist/Index.vue")
                },
                {
                    path: "/pick-list/view",
                    name: "pick-list-view",
                    meta: {
                        menuName: "Picking List"
                    },
                    component: () =>
                        import ("./views/picklist/View.vue")
                },
                {
                    path: "/pick-list/check",
                    name: "pick-list-check",
                    meta: {
                        menuName: "Picking List"
                    },
                    component: () =>
                        import ("./views/picklist/Check.vue")
                },
                {
                    path: "/checking-packing",
                    name: "checking-packing",
                    meta: {
                        menuName: "Checking & Packing"
                    },
                    component: () =>
                        import ("./views/checking/Index.vue")
                },
                {
                    path: "/checking-packing-ginee",
                    name: "checking-packing-ginee",
                    meta: {
                        menuName: "Checking & Packing"
                    },
                    component: () =>
                        import ("./views/checking/IndexGinee.vue")
                },
                // END DO

                /**
                 *
                 * START RDO
                 *
                 * **/
                {
                    path: "/return-delivery-order",
                    name: "return-delivery-order",
                    meta: {
                        menuName: "Return Delivery Order"
                    },
                    component: () =>
                        import ("./views/returndeliveryorder/Index.vue")
                },
                {
                    path: "/return-delivery-order/add",
                    name: "return-delivery-order-add",
                    meta: {
                        menuName: "Return Delivery Order"
                    },
                    component: () =>
                        import ("./views/returndeliveryorder/Add.vue")
                },
                {
                    path: "/return-delivery-order/view",
                    name: "return-delivery-order-view",
                    meta: {
                        menuName: "Return Delivery Order"
                    },
                    component: () =>
                        import ("./views/returndeliveryorder/View.vue")
                },
                {
                    path: "/return-delivery-order/check",
                    name: "return-delivery-order-check",
                    meta: {
                        menuName: "Return Delivery Order"
                    },
                    component: () =>
                        import ("./views/returndeliveryorder/Check.vue")
                },
                {
                    path: "/return-delivery-order/background",
                    name: "return-delivery-order-background",
                    meta: {
                        menuName: "Return Delivery Order"
                    },
                    component: () =>
                        import ("./views/returndeliveryorder/Background.vue")
                },
                {
                    path: "/return-delivery-order/foreground",
                    name: "return-delivery-order-foreground",
                    meta: {
                        menuName: "Return Delivery Order"
                    },
                    component: () =>
                        import ("./views/returndeliveryorder/Foreground.vue")
                },
                /**
                 *
                 * END RDO
                 *
                 * **/

                // START REPORT


                // END REPORT
                // START MASTER

                // {
                //   path: '/master/uom',
                //   name: 'master-uom',
                //   component: () => import('./views/Home.vue')
                // },
                {
                    path: "/master/awb",
                    name: "awb",
                    meta: {
                        menuName: "AWB"
                    },
                    component: () =>
                        import ("./views/master/awb/Index.vue")
                },
                {
                    path: "/master/operator",
                    name: "operators",
                    meta: {
                        menuName: "Operators"
                    },
                    component: () =>
                        import ("./views/master/operator/Index.vue")
                },
                {
                    path: "/report/operation-report",
                    name: "operation-report",
                    meta: {
                        menuName: "Operation Report"
                    },
                    component: () =>
                        import ("./views/report/Operation.vue")
                },
                // CID Label
                {
                    path: "/master/cid-label",
                    name: "master-cid-label",
                    meta: {
                        menuName: "CID Label"
                    },
                    component: () =>
                        import ("./views/master/cid-label/Index.vue")
                },

                {
                    path: "/master/client",
                    name: "master-client",
                    meta: {
                        menuName: "Client"
                    },
                    component: () =>
                        import ("./views/master/client/Index.vue")
                },

                {
                    path: "/master/clientrates",
                    name: "master-client-rate",
                    meta: {
                        menuName: "Client Rates"
                    },
                    component: () =>
                        import ("./views/master/client-rate/Index.vue")
                },

                {
                    path: "/master/clientrates/view",
                    name: "master-client-rate-view",
                    meta: {
                        menuName: "Client Rates"
                    },
                    component: () =>
                        import ("./views/master/client-rate/ViewEdit.vue")
                },
                {
                    path: "/master/clientrates/add",
                    name: "master-client-rate-add",
                    meta: {
                        menuName: "Client Rates"
                    },
                    component: () =>
                        import ("./views/master/client-rate/Add.vue")
                },

                {
                    path: "/master/client-type",
                    name: "master-client-type",
                    meta: {
                        menuName: "Client Type"
                    },
                    component: () =>
                        import ("./views/master/client-type/Index.vue")
                },

                {
                    path: "/master/asset",
                    name: "master-asset",
                    meta: {
                        menuName: "Assets"
                    },
                    component: () =>
                        import ("./views/master/asset/Index.vue")
                },

                {
                    path: "/master/area",
                    name: "master-area",
                    meta: {
                        menuName: "Areas"
                    },
                    component: () =>
                        import ("./views/master/area/Index.vue")
                },

                {
                    path: "/master/transporter",
                    name: "master-transporter",
                    meta: {
                        menuName: "Transporters"
                    },
                    component: () =>
                        import ("./views/master/transporter/Index.vue")
                },

                {
                    path: "/master/transporter/add",
                    name: "master-transporter-add",
                    meta: {
                        menuName: "Transporters"
                    },
                    component: () =>
                        import ("./views/master/transporter/Add.vue")
                },

                {
                    path: "/master/transporter/view",
                    name: "master-transporter-view",
                    meta: {
                        menuName: "Transporters"
                    },
                    component: () =>
                        import ("./views/master/transporter/ViewEdit.vue")
                },

                {
                    path: "/master/vehicle-type",
                    name: "master-vehicle-type",
                    meta: {
                        menuName: "Vehicles Types"
                    },
                    component: () =>
                        import ("./views/master/vehicle-type/Index.vue")
                },

                {
                    path: "/master/service-type",
                    name: "master-service-type",
                    meta: {
                        menuName: "Service Types"
                    },
                    component: () =>
                        import ("./views/master/service-type/Index.vue")
                },
                {
                    path: "/master/contract-type",
                    name: "master-contract-type",
                    meta: {
                        menuName: "Vehicles Types"
                    },
                    component: () =>
                        import ("./views/master/contract-type/Index.vue")
                },

                {
                    path: "/master/vehicle",
                    name: "master-vehicle",
                    meta: {
                        menuName: "Vehicle"
                    },
                    component: () =>
                        import ("./views/master/vehicle/Index.vue")
                },

                {
                    path: "/master/section",
                    name: "master-section",
                    meta: {
                        menuName: "Sections"
                    },
                    component: () =>
                        import ("./views/master/section/Index.vue")
                },

                {
                    path: "/master/warehouse",
                    name: "master-warehouse",
                    meta: {
                        menuName: "Warehouses"
                    },
                    component: () =>
                        import ("./views/master/warehouse/Index.vue")
                },

                {
                    path: "/master/customer",
                    name: "master-customer",
                    meta: {
                        menuName: "Customer"
                    },
                    component: () =>
                        import ("./views/master/customer/Index.vue")
                },

                {
                    path: "/master/customer/add",
                    name: "master-customer-add",
                    meta: {
                        menuName: "Customer"
                    },
                    component: () =>
                        import ("./views/master/customer/Add.vue")
                },

                {
                    path: "/master/customer/view",
                    name: "master-customer-view",
                    meta: {
                        menuName: "Customer"
                    },
                    component: () =>
                        import ("./views/master/customer/ViewEdit.vue")
                },

                {
                    path: "/master/areas-matrix",
                    name: "master-areas-matrix",
                    meta: {
                        menuName: "Areas Matrix"
                    },
                    component: () =>
                        import ("./views/master/areas-matrix/Index.vue")
                },
                {
                    path: "/master/location",
                    name: "master-location",
                    meta: {
                        menuName: "Locations"
                    },
                    component: () =>
                        import ("./views/master/location/Index.vue")
                },

                {
                    path: "/master/location/add",
                    name: "master-location-add",
                    meta: {
                        menuName: "Locations"
                    },
                    component: () =>
                        import ("./views/master/location/Add.vue")
                },

                {
                    path: "/master/location/view",
                    name: "master-location-view",
                    meta: {
                        menuName: "Locations"
                    },
                    component: () =>
                        import ("./views/master/location/ViewEdit.vue")
                },

                {
                    path: "/master/location/sequence",
                    name: "master-location-sequence",
                    meta: {
                        menuName: "Locations"
                    },
                    component: () =>
                        import ("./views/master/location/Sequence.vue")
                },
                {
                    path: "/master/transaction-rate/create",
                    name: "master-transaction-rate-create",
                    meta: {
                        menuName: "Transaction Rate"
                    },
                    component: () =>
                        import ("./views/master/client-transaction-rate/Create.vue")
                },
                {
                    path: "/master/product-category",
                    name: "master-product-category",
                    meta: {
                        menuName: "Product Category"
                    },
                    component: () =>
                        import ("./views/master/product-category/Index.vue")
                },
                {
                    path: "/master/product-category-detail",
                    name: "master-product-category-detail",
                    meta: {
                        menuName: "Product Cat. Detail"
                    },
                    component: () =>
                        import ("./views/master/product-category-detail/Index.vue")
                },

                {
                    path: "/master/product",
                    name: "master-product",
                    meta: {
                        menuName: "Product"
                    },
                    component: () =>
                        import ("./views/master/products/Index.vue")
                },

                {
                    path: "/master/products/add",
                    name: "master-product-add",
                    meta: {
                        menuName: "Product"
                    },
                    component: () =>
                        import ("./views/master/products/Add.vue")
                },

                {
                    path: "/master/products/view",
                    name: "master-product-view",
                    meta: {
                        menuName: "Product"
                    },
                    component: () =>
                        import ("./views/master/products/ViewEdit.vue")
                },
                {
                    path: "/master/uom",
                    name: "master-uom",
                    meta: {
                        menuName: "UoM"
                    },
                    component: () =>
                        import ("./views/master/uom/Index.vue")
                },

                {
                    path: "/master/movement-strategy",
                    name: "master-movement-strategy",
                    meta: {
                        menuName: "Movement Strategy"
                    },
                    component: () =>
                        import ("./views/master/movementstrategy/Index.vue")
                },
                {
                    path: "/master/movement-strategy/add",
                    name: "master-movement-strategy-add",
                    meta: {
                        menuName: "Movement Strategy"
                    },
                    component: () =>
                        import ("./views/master/movementstrategy/Add.vue")
                },
                {
                    path: "/master/movement-strategy/view",
                    name: "master-movement-strategy-view",
                    meta: {
                        menuName: "Movement Strategy"
                    },
                    component: () =>
                        import ("./views/master/movementstrategy/View.vue")
                },

                {
                    path: "/master/transporters-mode",
                    name: "master-transporter-mode",
                    meta: {
                        menuName: "Transporter Mode"
                    },
                    component: () =>
                        import ("./views/master/transporter-mode/Index.vue")
                },

                // transpoerter_rate
                {
                    path: "/master/transporterrates",
                    name: "master-transporter-rate",
                    meta: {
                        menuName: "Transporter Rates"
                    },
                    component: () =>
                        import ("./views/master/transporter-rate/Index.vue")
                },
                {
                    path: "/master/transporterrates/add",
                    name: "master-transporter-rate-add",
                    meta: {
                        menuName: "Transporter Rates"
                    },
                    component: () =>
                        import ("./views/master/transporter-rate/Add.vue")
                },
                {
                    path: "/master/transporterrates/view",
                    name: "master-transporter-rate-view",
                    meta: {
                        menuName: "Transporter Rates"
                    },
                    component: () =>
                        import ("./views/master/transporter-rate/ViewEdit.vue")
                },

                {
                    path: "/master/pod-code",
                    name: "master-podcodes",
                    meta: {
                        menuName: "POD Codes"
                    },
                    component: () =>
                        import ("./views/master/podcodes/Index.vue")
                },
                {
                    path: "/master/order-type",
                    name: "master-order-type",
                    meta: {
                        menuName: "Order Type"
                    },
                    component: () =>
                        import ("./views/master/orderTypes/Index.vue")
                },
                {
                    path: "/master/container",
                    name: "master-container",
                    meta: {
                        menuName: "Container"
                    },
                    component: () =>
                        import ("./views/master/container/Index.vue")
                },

                {
                    path: "/master/packaging",
                    name: "master-packaging",
                    meta: {
                        menuName: "Packaging"
                    },
                    component: () =>
                        import ("./views/master/packaging/Index.vue")
                },
                // END MASTER

                // START INVENTORIES
                {
                    path: "/inventory",
                    name: "inventory",
                    meta: {
                        menuName: "Inventory List"
                    },
                    component: () =>
                        import ("./views/inventory/inventory/Index.vue")
                },

                // Movement Order
                {
                    path: "/movement-order",
                    name: "movement-order",
                    meta: {
                        menuName: "Movement Order"
                    },
                    component: () =>
                        import ("./views/inventory/movement-order/Index.vue")
                },
                {
                    path: "/movement-order/add",
                    name: "movement-order-add",
                    meta: {
                        menuName: "Movement Order"
                    },
                    component: () =>
                        import ("./views/inventory/movement-order/Add.vue")
                },
                {
                    path: "/stock-check",
                    name: "stock-check",
                    meta: {
                        menuName: "Inventory List"
                    },
                    component: () =>
                        import ("./views/inventory/stock-check/Index.vue")
                },
                {
                    path: "/stock-check/add",
                    name: "stock-check-add",
                    meta: {
                        menuName: "Inventory List"
                    },
                    component: () =>
                        import ("./views/inventory/stock-check/Add.vue")
                },
                {
                    path: "/stock-check/view",
                    name: "stock-check-view",
                    meta: {
                        menuName: "Inventory List"
                    },
                    component: () =>
                        import ("./views/inventory/stock-check/View.vue")
                },
                {
                    path: "/stock-check/count",
                    name: "stock-check-count",
                    meta: {
                        menuName: "Inventory List"
                    },
                    component: () =>
                        import ("./views/inventory/stock-check/Count.vue")
                },

                // Stock Transfer
                {
                    path: "/stock-transfer",
                    name: "stock-transfer",
                    meta: {
                        menuName: "Stock Transfer"
                    },
                    component: () =>
                        import ("./views/inventory/stock-transfer/Index.vue")
                },
                {
                    path: "/stock-transfer/add",
                    name: "stock-transfer-add",
                    meta: {
                        menuName: "Stock Transfer"
                    },
                    component: () =>
                        import ("./views/inventory/stock-transfer/Add.vue")
                },
                {
                    path: "/stock-transfer/view",
                    name: "stock-transfer-view",
                    meta: {
                        menuName: "Stock Transfer"
                    },
                    component: () =>
                        import ("./views/inventory/stock-transfer/ViewEdit.vue")
                },
                {
                    path: "/stock-transfer/put",
                    name: "stock-transfer-put",
                    meta: {
                        menuName: "Stock Transfer"
                    },
                    component: () =>
                        import ("./views/inventory/stock-transfer/Put.vue")
                },
                {
                    path: "/stock-transfer/pick",
                    name: "stock-transfer-pick",
                    meta: {
                        menuName: "Stock Transfer"
                    },
                    component: () =>
                        import ("./views/inventory/stock-transfer/Pick.vue")
                },
                // Replenish
                {
                    path: "/replenish",
                    name: "replenish",
                    meta: {
                        menuName: "Replenish"
                    },
                    component: () =>
                        import ("./views/inventory/replenish/Index.vue")
                },
                {
                    path: "/replenish/add",
                    name: "replenish-add",
                    meta: {
                        menuName: "Replenish"
                    },
                    component: () =>
                        import ("./views/inventory/replenish/Add.vue")
                },
                {
                    path: "/replenish/view",
                    name: "replenish-view",
                    meta: {
                        menuName: "Replenish"
                    },
                    component: () =>
                        import ("./views/inventory/replenish/View.vue")
                },
                {
                    path: "/adjust",
                    name: "adjust",
                    meta: {
                        menuName: "Inventory Adjust"
                    },
                    component: () =>
                        import ("./views/inventory/adjust/Index.vue")
                },
                // END INVENTORIES

                /* START VAS */
                {
                    path: "/production-order",
                    name: "production-order",
                    meta: {
                        menuName: "Production Order",
                        type: "Production Order",
                        slug: "production-order"
                    },
                    component: () =>
                        import ("./views/valueaddedservice/Index.vue")
                },
                {
                    path: "/unpack-order",
                    name: "unpack-order",
                    meta: {
                        menuName: "Unpack Order",
                        type: "Unpack Order",
                        slug: "unpack-order"
                    },
                    component: () =>
                        import ("./views/valueaddedservice/Index.vue")
                },
                {
                    path: "/production-order/add",
                    name: "production-order-add",
                    meta: {
                        menuName: "Production Order",
                        type: "Production Order",
                        slug: "production-order"
                    },
                    component: () =>
                        import ("./views/valueaddedservice/Add.vue")
                },
                {
                    path: "/unpack-order/add",
                    name: "unpack-order-add",
                    meta: {
                        menuName: "Unpack Order",
                        type: "Unpack Order",
                        slug: "unpack-order"
                    },
                    component: () =>
                        import ("./views/valueaddedservice/Add.vue")
                },
                {
                    path: "/production-order/view",
                    name: "production-order-view",
                    meta: {
                        menuName: "Production Order",
                        type: "Production Order",
                    },
                    component: () =>
                        import ("./views/valueaddedservice/View.vue")
                },
                {
                    path: "/unpack-order/view",
                    name: "unpack-order-view",
                    meta: {
                        menuName: "Unpack Order",
                        type: "Unpack Order",
                    },
                    component: () =>
                        import ("./views/valueaddedservice/View.vue")
                },
                {
                    path: "/production-order/pick-background",
                    name: "vas-pick-background",
                    meta: {
                        menuName: "Production Order"
                    },
                    component: () =>
                        import ("./views/valueaddedservice/PickBackground.vue")
                },
                {
                    path: "/production-order/put-background",
                    name: "vas-put-background",
                    meta: {
                        menuName: "Production Order"
                    },
                    component: () =>
                        import ("./views/valueaddedservice/PutBackground.vue")
                },
                {
                    path: "/production-order/put-foreground",
                    name: "vas-put-foreground",
                    meta: {
                        menuName: "Production Order"
                    },
                    component: () =>
                        import ("./views/valueaddedservice/PutForeground.vue")
                },
                {
                    path: "/production-order/putaway-background",
                    name: "production-order-putaway-background",
                    meta: {
                        menuName: "Production Order"
                    },
                    component: () =>
                        import ("./views/valueaddedservice/productionorder/PutawayBackground.vue")
                },
                {
                    path: "/fg-receiving",
                    name: "fg-receiving",
                    meta: {
                        menuName: "FG Receiving"
                    },
                    component: () =>
                        import ("./views/valueaddedservice/fgreceiving/Index.vue")
                },
                {
                    path: "/fg-receiving/add",
                    name: "fg-receiving-add",
                    meta: {
                        menuName: "FG Receiving"
                    },
                    component: () =>
                        import ("./views/valueaddedservice/fgreceiving/Add.vue")
                },
                {
                    path: "/fg-receiving/view",
                    name: "fg-receiving-view",
                    meta: {
                        menuName: "FG Receiving"
                    },
                    component: () =>
                        import ("./views/valueaddedservice/fgreceiving/View.vue")
                },
                {
                    path: "/setting",
                    name: "setting",
                    meta: {
                        menuName: "Setting"
                    },
                    component: () =>
                        import ("./views/Setting.vue")
                },

                /* END VAS */
                {
                    path: "/rfmanagement",
                    name: "rfmanagement",
                    meta: {
                        menuName: "RF Mobile Management"
                    },
                    component: () =>
                        import ("./views/rfmanagement/Index.vue")
                },
                {
                    path: "/rfmanagement/list",
                    name: "rfmanagement-list",
                    meta: {
                        menuName: "RF Mobile Management"
                    },
                    component: () =>
                        import ("./views/rfmanagement/List.vue")
                },
                {
                    path: "/rfmanagement/view",
                    name: "rfmanagement-view",
                    meta: {
                        menuName: "RF Mobile Management"
                    },
                    component: () =>
                        import ("./views/rfmanagement/View.vue")
                },
                {
                    path: "/couriermanagement",
                    name: "couriermanagement",
                    meta: {
                        menuName: "Courier Mobile Management"
                    },
                    component: () =>
                        import ("./views/couriermanagement/Index.vue")
                },
                {
                    path: "/couriermanagement/list",
                    name: "couriermanagement-list",
                    meta: {
                        menuName: "Courier Mobile Management"
                    },
                    component: () =>
                        import ("./views/couriermanagement/List.vue")
                },
                {
                    path: "/couriermanagement/view",
                    name: "couriermanagement-view",
                    meta: {
                        menuName: "Courier Mobile Management"
                    },
                    component: () =>
                        import ("./views/couriermanagement/View.vue")
                },
                {
                    path: "/support/resend-awb",
                    name: "support-resend-awb",
                    meta: {
                        menuName: "Resend AWB"
                    },
                    component: () =>
                        import ("./views/support_tools/ResendAwb.vue")
                },
                {
                    path: "/support/transactional-report",
                    name: "support-transactional-report",
                    meta: {
                        menuName: "Transactional Report"
                    },
                    component: () =>
                        import ("./views/support_tools/TransactionalReport.vue")
                },
                {
                    path: "/support/uncommit-outbound",
                    name: "support-uncommit-outbound",
                    meta: {
                        menuName: "Uncommit Outbound"
                    },
                    component: () =>
                        import ("./views/support_tools/UncommitOutbound.vue")
                },
                {
                    path: "/support/cancel-outbound",
                    name: "support-cancel-outbound",
                    meta: {
                        menuName: "Cancel Outbound"
                    },
                    component: () =>
                        import ("./views/support_tools/CancelOrder.vue")
                },
                {
                    path: "/support/change-transporter",
                    name: "support-change-transporter",
                    meta: {
                        menuName: "Change Transporter"
                    },
                    component: () =>
                        import ("./views/support_tools/ChangeTransporter.vue")
                },
                {
                    path: "/support/outbound-api",
                    name: "support-outbound-api",
                    meta: {
                        menuName: "Outbound Api"
                    },
                    component: () =>
                        import ("./views/support_tools/OutboundApi.vue")
                },
                {
                    path: "/support/upload-gi",
                    name: "support-upload-gi",
                    meta: {
                        menuName: "Upload GI"
                    },
                    component: () =>
                        import ("./views/support_tools/UploadGi.vue")
                },
                {
                    path: "/support/warehouse-stock-transfer",
                    name: "support-warehouse-stock-transfer",
                    meta: {
                        menuName: "Upload GI"
                    },
                    component: () =>
                        import ("./views/support_tools/WarehouseStockTransfer.vue")
                },
                {
                    path: "/support/resend-api",
                    name: "resend-api",
                    meta: {
                        menuName: "Resend API AWB SAP"
                    },
                    component: () =>
                        import ("./views/support_tools/ResendApi.vue")
                },
                {
                    path: "/support/update-sap-area",
                    name: "update-sap-area",
                    meta: {
                        menuName: "Update SAP Area"
                    },
                    component: () =>
                        import ("./views/support_tools/UpdateSapArea.vue")
                },
            ]
        },
        // =============================================================================
        // FULL PAGE LAYOUTS
        // =============================================================================
        {
            path: "",
            component: () =>
                import ("@/layouts/full-page/FullPage.vue"),
            children: [
                // =============================================================================
                // PAGES
                // =============================================================================
                {
                    path: "/auth",
                    name: "page-login",
                    component: () =>
                        import ("@/views/pages/Login.vue")
                },
                {
                    path: "/pages/error-404",
                    name: "page-error-404",
                    component: () =>
                        import ("@/views/pages/Error404.vue")
                }
            ]
        },
        // Redirect to 404 page, if no match found
        {
            path: "*",
            redirect: "/pages/error-404"
        }
    ]
});

router.afterEach(() => {
    // Remove initial loading
    const appLoading = document.getElementById("loading-bg");
    if (appLoading) {
        appLoading.style.display = "none";
    }
});

export default router;
